module.exports = __webpack_public_path__ + "img/nicetohave-product-design-11.e0d08e5b.jpg";